<form [formGroup]="form">
  <div>
    <h4>Pay rate</h4>
    <div class="row">
      <div class="col-4 col-lg-2">
        <mojo-currency-dropdown
          [parentForm]="form"
          controlName="payRateCurrency"
        >
        </mojo-currency-dropdown>
      </div>
      <mat-form-field
        color="accent"
        class="col-4 col-lg-2 pl-0"
      >
        <mat-label>Min</mat-label>
        <input
          matInput
          id="minPayRate"
          formControlName="minPayRate"
          placeholder="Min"
          mask="coma_separator"
        >
      </mat-form-field>
      <mat-form-field
        color="accent"
        class="col-4 col-lg-2 pl-0"
      >
        <mat-label>Max</mat-label>
        <input
          matInput
          id="maxPayRate"
          formControlName="maxPayRate"
          placeholder="Max"
          mask="coma_separator"
        >
      </mat-form-field>
      <mat-form-field
        color="accent"
        class="col-6 col-lg-4 no-label"
      >
        <mat-select formControlName="payRatePeriod">
          <mat-option
            *ngFor="let item of timePeriodsList"
            [value]="item"
          >
            {{item}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div>
    <h4>Bill rate</h4>
    <div class="row">
      <div class="col-4 col-lg-2">
        <mojo-currency-dropdown
          [parentForm]="form"
          controlName="billRateCurrency"
        >
        </mojo-currency-dropdown>
      </div>
      <mat-form-field
        class="col-4 col-lg-2 pl-0"
        color="accent"
      >
        <mat-label>Min</mat-label>
        <input
          matInput
          type="text"
          id="minBillRate"
          placeholder="Min"
          formControlName="minBillRate"
          mask="coma_separator"
        />
      </mat-form-field>
      <mat-form-field
        class="col-4 col-lg-2 pl-0"
        color="accent"
      >
        <mat-label>Max</mat-label>
        <input
          matInput
          type="text"
          placeholder="Max"
          formControlName="maxBillRate"
          mask="coma_separator"
        />
      </mat-form-field>
      <mat-form-field
        color="accent"
        class="col-6 col-lg-4 no-label"
      >
        <mat-select formControlName="billRatePeriod">
          <mat-option
            *ngFor="let item of timePeriodsList"
            [value]="item"
          >
            {{item}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</form>
